module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/settings-2-764578c73670c7c59c578e6380a0c739.svg";